import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const LINKS = [
    { to: "/admin", label: "Dashboard", end: true },
    { to: "/admin/site-settings", label: "Site Settings" },
    { to: "/admin/theme", label: "Theme" },
    { to: "/admin/banners", label: "Banners" },
    { to: "/admin/categories", label: "Categories" },
    { to: "/admin/sale-banners", label: "Sales" },
    { to: "/admin/sales-overview", label: "Sales Overview" },
    { to: "/admin/products", label: "Products" },
    { to: "/admin/bestsellers", label: "Bestsellers" },
    { to: "/admin/orders", label: "Orders" },
    { to: "/admin/images", label: "Images" },
    { to: "/admin/coupons", label: "Coupons" },
    { to: "/admin/change-password", label: "Change Password" },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    return (
        <div className="min-h-screen bg-neutral-100 text-black" data-testid="admin-shell">
            <div className="bg-black text-white border-b-2 border-black">
                <div className="max-w-[1600px] mx-auto px-4 md:px-8 flex items-center justify-between h-14">
                    <Link to="/admin" className="font-display text-2xl tracking-tighter">CLONZO · ADMIN</Link>
                    <div className="flex items-center gap-4 font-mono text-xs uppercase">
                        <Link to="/" className="opacity-70 hover:opacity-100">View Store →</Link>
                        <div className="opacity-70">{user?.email}</div>
                        <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout">Logout</button>
                    </div>
                </div>
            </div>
            <div className="max-w-[1600px] mx-auto grid grid-cols-[220px_1fr]">
                <aside className="border-r-2 border-black bg-white min-h-[calc(100vh-3.5rem)] p-4">
                    <div className="flex flex-col gap-1">
                        {LINKS.map(l => (
                            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`adm-nav-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
                                className={({ isActive }) => `px-3 py-2 font-mono text-xs uppercase border-2 ${isActive ? "bg-black text-white border-black" : "border-transparent hover:border-black"}`}>
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </aside>
                <div className="p-6"><Outlet /></div>
            </div>
        </div>
    );
}
